import { ArrowLeft, Eye } from 'lucide-react'
import { useImpersonation } from '@/contexts/ImpersonationContext'

export function ImpersonationBanner() {
  const { isImpersonating, impersonatedAccount, stopImpersonation } =
    useImpersonation()

  if (!isImpersonating) {
    return null
  }

  return (
    <div className="fixed left-0 right-0 top-0 z-[100] flex h-12 items-center justify-between bg-amber-500 px-4 text-amber-950">
      <div className="flex items-center gap-2">
        <Eye className="h-5 w-5" />
        <span className="font-medium">
          Viewing as: {impersonatedAccount?.name || 'Unknown Account'}
        </span>
      </div>
      <button
        onClick={stopImpersonation}
        className="flex items-center gap-2 rounded-md bg-amber-600 px-3 py-1.5 text-sm font-medium transition-colors hover:bg-amber-700"
      >
        <ArrowLeft className="h-4 w-4" />
        Return to Admin
      </button>
    </div>
  )
}
